export default __webpack_public_path__ + "static/media/content-deco-4.4f69a26d.webp";